import { render, staticRenderFns } from "./BuffetManage.vue?vue&type=template&id=60335a28&scoped=true"
import script from "./BuffetManage.vue?vue&type=script&lang=js"
export * from "./BuffetManage.vue?vue&type=script&lang=js"
import style0 from "./BuffetManage.vue?vue&type=style&index=0&id=60335a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60335a28",
  null
  
)

export default component.exports